import { push } from "connected-react-router";
import { connect } from "react-redux";

import Home from "./components/Home";

const mapStateToProps = state => ({
  theme: state.themes.theme
});

export default connect(
  mapStateToProps,
  { push }
)(Home);
